import { render } from "./ReviewForm.vue?vue&type=template&id=324f6e04&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"

import "./ReviewForm.vue?vue&type=style&index=0&id=324f6e04&lang=scss"
import "./ReviewForm.vue?vue&type=style&index=1&id=324f6e04&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324f6e04"]])

export default __exports__